import * as React from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TransformYourSpace() {
  return <section data-section-id="221448" id="efficienza-dimostrata" className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-background bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680532/img/italian_lush_farmland_irrigation.png')] bg-cover bg-center bg-no-repeat">
      {}
      <div className="absolute inset-0 bg-primary/40 backdrop-blur-[2px]" />

      <div className="relative z-10 flex w-full max-w-7xl flex-col items-center justify-center px-4 text-center">
        <h1 className="font-default mb-8 text-6xl leading-[0.85] tracking-tight text-white drop-shadow-2xl md:text-8xl lg:text-[10rem] xl:text-[12rem]">
          RISULTATI CHE<br />CONTANO.
        </h1>

        <Button asChild size="lg" className="group relative h-auto overflow-hidden rounded-lg bg-secondary px-10 py-6 font-default text-2xl uppercase tracking-widest text-secondary-foreground shadow-3xl transition-all duration-300 hover:-translate-y-1 hover:scale-105 hover:bg-secondary/90 md:px-14 md:py-8 md:text-3xl">
          <Link to="/ResultsPage">
            <span className="relative z-10">Download PDF Case Study</span>
            {}
            <div className="absolute inset-0 -z-0 h-full w-full scale-x-0 bg-white/10 opacity-0 transition-all duration-500 group-hover:scale-x-100 group-hover:opacity-100" style={{
            transformOrigin: 'left center'
          }} />
          </Link>
        </Button>
      </div>

      <div className="absolute bottom-8 left-1/2 z-10 -translate-x-1/2 animate-pulse">
        <ChevronDown className="h-12 w-12 text-white drop-shadow-lg" strokeWidth={1.5} />
      </div>
    </section>;
}